module.exports = __webpack_public_path__ + "static/Venafi_logo-ee754fe6bf8087dac70d2a1cf2cffa00.png";